import {
  Component,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { OpsPaymentMethodsSettingsComponent } from './ops-payment-methods-settings.component';
import { UserSubscription } from '@ops/shared-types';

@Component({
  selector: 'ops-payment-methods-settings-modal',
  standalone: true,
  imports: [CommonModule, OpsPaymentMethodsSettingsComponent],
  template: `
    <div class="modal-overlay"   tabindex="0">
      <div class="modal-content" (click)="$event.stopPropagation()">
        <ops-payment-methods-settings
          [selectedSubscriptionData]="selectedSubscriptionData"
          (closeModal)="onClose()"
          (paymentMethodSelected)="handlePaymentMethodSelected($event)"
          (updateDefaultPaymentMethodForSubscription)="onUpdateDefaultPaymentMethodForSubscription()" 
        ></ops-payment-methods-settings>
      </div>
    </div>
  `,
  styles: [`
    .modal-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(50, 115, 244, 0.37);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1000;

      
    }
    
    .modal-content {
      background: white;
      border-radius: 8px;
      max-width: 90vw;
      max-height: 90vh;
      overflow: auto;
    box-shadow: 0px 5px 15px 1px #6c89f1, -1px -5px 15px 1px #6c89f1;
    }
  `]
})
export class OpsPaymentMethodsSettingsModalComponent {
  @Input() selectedSubscriptionData: UserSubscription | null = null;
  @Output() paymentMethodSelected = new EventEmitter<any>();
  @Output() closeModal = new EventEmitter<void>();
  @Output() updateDefaultPaymentMethodForSubscription = new EventEmitter<void>();

  onClose(): void {
    this.closeModal.emit();
  }

  onUpdateDefaultPaymentMethodForSubscription(): void {
    this.updateDefaultPaymentMethodForSubscription.emit();
  }

  handlePaymentMethodSelected(paymentMethod: any): void {
    this.paymentMethodSelected.emit(paymentMethod);
  }
}

